import { BonusReceiptGate } from "../../features/bonuses/BonusReceiptGate";
import { PushEnableBanner } from "../controls/PushEnableBanner";
import { BottomNav } from "./BottomNav";
import { PageTitleBar } from "./PageTitleBar";
import { SideNav } from "./SideNav";
import { TopBar } from "./TopBar";

// قوقعة الصفحة: تتمدّد مع عرض الشاشة، والتبويبات الجانبية تُخفى في كل صفحات الأقسام
// (أي صفحة لها عنوان) وتبقى في الرئيسية فقط. زر الرئيسية موجود في شريط العنوان.
export const AppShell = ({ title, subtitle, children, actions, bare, titleClassName }) => {
  const hideSide = bare === undefined ? Boolean(title) : bare;

  return (
    <div
      className={`min-h-[100dvh] bg-background px-4 pb-32 sm:px-8 sm:pb-10 lg:px-12 2xl:px-16 ${
        title
          ? "pt-[max(5.5rem,calc(env(safe-area-inset-top)+5rem))]"
          : "pt-[max(1.25rem,env(safe-area-inset-top))]"
      }`}
    >
      {title ? <PageTitleBar title={title} subtitle={subtitle} titleClassName={titleClassName} /> : null}
      <div className="w-full">
        {title ? null : <TopBar />}
        <div className={`grid gap-8 ${hideSide ? "" : "lg:grid-cols-[240px_minmax(0,1fr)]"} ${
          title ? "" : "mt-4"}`}>
          {hideSide ? null : (
            <aside className={`hidden min-w-0 lg:block lg:self-start lg:sticky ${
              title ? "lg:top-24" : "lg:top-6"}`}>
              <SideNav />
            </aside>
          )}
          <main className="min-w-0">
            <PushEnableBanner />
            {actions ? <div className="mb-6 flex flex-wrap justify-end gap-4">{actions}</div> : null}
            {children}
          </main>
        </div>
      </div>
      <BottomNav />
      <BonusReceiptGate />
    </div>
  );
};
